import { render, staticRenderFns } from "./HowToTournament.vue?vue&type=template&id=4a898d51&"
import script from "./HowToTournament.vue?vue&type=script&lang=js&"
export * from "./HowToTournament.vue?vue&type=script&lang=js&"
import style0 from "./HowToTournament.vue?vue&type=style&index=0&id=4a898d51&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports